//some most commonly used important variables in the application itself.
export const API_URL='https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC=10;
export const RES_PER_PAGE=10;
export const KEY='164f4bb3-1f54-4c57-acdb-592a09d0cc69';
export const MODAL_CLOSE_SEC=2.5;
